module.exports = __webpack_public_path__ + "img/crossroad-tflight.f65db689.svg";